export default __webpack_public_path__ + "static/brand-logo-1e92b5687b8cfdd6e0cf6bcf1be83539.svg";